var exports = {
  "n": "xcc377c0b--95ce30--playerIcon",
  "W": "xcc377c0b--95ce30--playerIconSmall",
};

module.exports = exports;
